// import { io } from "socket.io-client";



// export const socket = io("http://localhost:7700", {
//   transports: ["websocket"],
//   autoConnect: false,
//   reconnection: true,
//   reconnectionAttempts: Infinity,
//   reconnectionDelay: 1000,
// });
import { io } from "socket.io-client";
import {socket_url} from "./Utils/Config"

export const socket = io(socket_url, {
  
  transports: ["websocket"],
  autoConnect: false,
});
